export const RESPONSE_COMPONENT_FULL_BLOCKS = [
  { type: 'heading', level: 2, content: 'Dense Markdown Elements & UI Blocks' },
  {
    type: 'markdown',
    content:
      'This is a dummy markdown response with dense content to simulate various chat response elements.',
  },
  {
    type: 'code',
    language: 'javascript',
    content: 'function simulateResponse() {\n  console.log("This is a dummy code block!");\n  return true;\n}',
  },
  {
    type: 'table',
    data: [
      { id: 1, name: 'Item A', value: 100 },
      { id: 2, name: 'Item B', value: 200 },
    ],
  },
  {
    type: 'list',
    items: [
      'First dense bullet point explanation.',
      'Second bullet point for testing.',
      'Third item in the list.',
    ],
  },
  { type: 'quote', content: 'Simulation is the imitation of the operation of a real-world process.' },
  { type: 'callout', style: 'info', content: 'Voice recording apps use waveform visualization.' },
  { type: 'callout', style: 'warning', content: 'High FFT size can reduce performance.' },
  { type: 'callout', style: 'success', content: 'Successfully mapped all parameters!' },
  {
    type: 'checklist',
    items: [
      { text: 'Microphone access', checked: true },
      { text: 'Waveform rendering', checked: true },
      { text: 'Save recording', checked: false },
    ],
  },
  { type: 'json', title: 'Waveform Config', data: { type: 'waveform', style: 'scrolling', color: 'blue' } },
  {
    type: 'card',
    title: '🎙 Recording',
    subtitle: 'Meeting Notes',
    content: 'Duration: 2:14 | Status: Completed',
  },
  { type: 'divider' },
  { type: 'tool', toolName: 'buildWaveform', status: 'success', result: 'Waveform generated in 42ms.' },
  { type: 'media', mediaType: 'image', url: '', caption: 'Minimal waveform' },
]
